<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12>
      <v-card class="mb-4">
        <v-card-title>
          <v-flex xs12 md1>
            <v-avatar size="70">
              <img :src="safeImage" @error="imageError()" ref="logo" alt>
              <v-btn
                absolute
                dark
                fab
                bottom
                right
                color="blue"
                small
                class="image-edit"
                @click.prevent="imageChangeModal = true"
                v-if="canEdit"
              >
                <v-icon>mode_edit</v-icon>
              </v-btn>
            </v-avatar>
            <change-image
              v-if="canEdit && imageChangeModal"
              @imageCropped="imageCropped"
              @modalClose="imageChangeModal = false"
              :isShow="imageChangeModal"
            ></change-image>
          </v-flex>
          <v-flex xs6 md4 class="mt-4">
            <span class="ml-4">
              <strong style="font-size: 1.2rem">{{fullName}}</strong>
            </span>
            <p class="ml-4">
              {{userData.username}}
              <v-icon v-if="!isMakerlab" small @click="urlCalendar" class="mr-2">calendar_today</v-icon>
            </p>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex mt-2 xs12 md7 class="text-xs-center text-md-right">
            <v-chip
              label
              color="blue"
              outline
              v-for="group 
                            in userData.groups"
              :key="group"
            >{{group}}</v-chip>
            <v-spacer></v-spacer>
            <!-- @click.prevent="goToUnidade(un.slug)"> -->
            <v-chip
              label
              v-for="un 
                                in userData.unidade_detail"
              :key="un.name"
              color="amber"
              outline
            >{{un.name}}</v-chip>
          </v-flex>
        </v-card-title>
        <v-divider></v-divider>
        <!-- VISÃO DE MUNDOMAKER -->
        <v-card-text class="mx-0 px-0 mt-0 pt-0" v-if="!isMakerlab">
          <v-tabs color="blue lighten-1" dark class="mx-0 pt-0 mt-0">
            <v-tab
              class="mx-0 pt-0 mt-0"
              v-for="tab in tabs"
              :key="tab.name"
              v-if="hasPerm(tab.permission)"
              @click="show_plot=true"
            >{{ tab.name }}</v-tab>
            <v-tab style="margin-left: 320px">
              <v-icon v-if="editing" size="25" @click="dialog = true" style="float: right">delete</v-icon>
            </v-tab>

            <v-tab-item key="Sobre" class="px-3 py-2">
              <profile-text
                title="Sobre : "
                v-model="tempData.description"
                :editing="editing"
                inputType="multilinetext"
              ></profile-text>
              <profile-text
                title="Papeis : "
                chiplist
                v-model="tempData.groups"
                :editing="editing"
                inputType="multiselect"
                :selectOptions="options.groups"
              ></profile-text>
              <profile-text
                title="Empresa : "
                v-model="compLab.name"
              ></profile-text>
              <profile-text
                title="Unidades : "
                chiplist
                v-model="tempData.unidade"
                :editing="editing"
                inputType="multiunidade"
                :selectOptions="unidadeDisponivel"
              ></profile-text>
              <profile-text
                title="Mediador : "
                :editing="editing"
                v-if="isStudent"
                v-model="selectedMediador"
                showbykey="full_name"
                inputType="mediadorselect"
                :selectOptions="availableMediadores"
              ></profile-text>
            </v-tab-item>
            <v-tab-item key="Pessoal" class="px-3 py-2">
              <v-layout row wrap>
                <v-flex xs6>
                  <profile-text
                    title="Email : "
                    v-model="tempData.email"
                    :editing="editing"
                    :last="true"
                  ></profile-text>
                  <profile-text
                    title="Data de Nascimento"
                    v-model="tempData.birthdate"
                    :last="true"
                    :editing="editing"
                    inputType="datepicker"
                    date
                  ></profile-text>
                  <profile-text
                    title="Gênero : "
                    v-model="tempData.gender"
                    :editing="editing"
                    :last="true"
                  ></profile-text>
                  <profile-text
                    title="RG : "
                    mask="##.###.###-#"
                    v-model="tempData.rg"
                    :last="true"
                    :editing="editing"
                  ></profile-text>
                </v-flex>
                <v-flex xs6>
                  <profile-text
                    title="CPF : "
                    mask="###.###.###-##"
                    :last="true"
                    v-model="userData.cpf"
                    :editing="editing"
                  ></profile-text>

                  <profile-text
                    v-if="isWorker"
                    title="Nacionalidade : "
                    :last="true"
                    v-model="tempData.nacionalidade"
                    :editing="editing"
                  ></profile-text>
                  <!-- <profile-text v-if='isWorker' title='Tipo Profissional : ' 
                                :last="true" 
                                v-model='tempData.tipoporof'
                  :editing='editing'></profile-text>-->
                  <profile-text
                    v-if="isWorker"
                    title="Estado Nascimento : "
                    :last="true"
                    v-model="tempData.estadonasc"
                    mask="AA"
                    :editing="editing"
                  ></profile-text>
                  <profile-text
                    v-if="isWorker"
                    title="Cidade Nascimento : "
                    :last="true"
                    v-model="tempData.cidadenasc"
                    :editing="editing"
                  ></profile-text>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item v-if="isStudent && canEvaluate" key="Adicionais" class="px-3 py-2">
              <profile-text
                title="Restrições : "
                :last="true"
                v-model="tempData.restricao"
                :editing="editing"
                input-type="multilinetext"
              ></profile-text>
              <profile-text
                title="Doenças : "
                v-model="tempData.doenca"
                :last="true"
                :editing="editing"
                input-type="multilinetext"
              ></profile-text>
              <profile-text
                title="Tratamento : "
                v-model="tempData.tratamento"
                :last="true"
                :editing="editing"
                input-type="multilinetext"
              ></profile-text>
            </v-tab-item>
            <v-tab-item key="Endereço" class="px-3 py-2">
              <v-layout row wrap>
                <v-flex xs6>
                  <profile-text
                    title="Logradouro : "
                    :last="true"
                    v-model="tempData.logradouro"
                    :editing="editing"
                  ></profile-text>
                  <profile-text
                    title="Número : "
                    v-model="tempData.numero"
                    :editing="editing"
                    :last="true"
                  ></profile-text>
                  <profile-text
                    title="Complemento : "
                    v-model="tempData.complemento"
                    :editing="editing"
                    :last="true"
                  ></profile-text>
                  <profile-text
                    title="Bairro : "
                    v-model="tempData.bairro"
                    :editing="editing"
                    :last="true"
                  ></profile-text>
                </v-flex>
                <v-flex xs6>
                  <profile-text
                    title="Cidade : "
                    v-model="tempData.cidade"
                    :editing="editing"
                    :last="true"
                  ></profile-text>
                  <profile-text
                    title="Estado : "
                    v-model="tempData.estado"
                    :last="true"
                    mask="AA"
                    :editing="editing"
                  ></profile-text>
                  <profile-text
                    title="Telefone : "
                    v-model="tempData.phonenumber"
                    :last="true"
                    mask="(##) #####-####"
                    :editing="editing"
                  ></profile-text>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="Familiares" class="px-3 py-2" >
              <h3 v-if="hasAlunos">Alunos</h3>
              <v-layout class="row" v-for="user in userData.alunos" :key="user.username">
                <div class="sm3 pb-2">
                  <router-link :to="user.username">
                    <v-avatar>
                      <img :src="imageDefault(user.profilePic)">
                    </v-avatar>
                  </router-link>
                </div>
                <div class="sm9 ml-3 mt-3">
                  <router-link :to="user.username">
                    <h3 class>
                      {{user.username + ' - ' +
                      user.first_name + ' ' +
                      user.last_name}}
                    </h3>
                  </router-link>
                </div>
              </v-layout>
              <h3 v-if="hasDependentes">Dependentes</h3>
              <v-layout class="row" v-for="user in userData.dependentes" :key="user.username">
                <div class="sm3 pb-2">
                  <router-link :to="user.aluno.username">
                    <v-avatar>
                      <img :src="imageDefault(user.aluno.profilePic)">
                    </v-avatar>
                  </router-link>
                </div>
                <div class="sm9 ml-3 mt-3">
                  <router-link :to="user.aluno.username">
                    <h3 class>
                      {{user.aluno.username + ' - ' +
                      user.aluno.first_name + ' ' +
                      user.aluno.last_name}}
                    </h3>
                  </router-link>
                </div>
              </v-layout>
              <h3 class="mb-1" v-if="hasFamiliares">Parentes</h3>
              <v-layout class="row" v-for="user in tempData.familiares" :key="user.username">
                <div class="sm3">
                  <router-link :to="user.parente.username">
                    <v-avatar>
                      <img :src="imageDefault(user.parente.profilePic)">
                    </v-avatar>
                  </router-link>
                </div>
                <div class="sm9 ml-3 pb-4">
                  <h3>
                    <router-link :to="user.parente.username">
                      {{user.parente.username + ' - ' + user.parente.first_name + ' ' + user.parente.last_name}}
                      <v-icon
                        v-if="canSeeLegal && user.respfinanceiro"
                        style="margin-bottom: 6px"
                      >monetization_on</v-icon>
                    </router-link>
                    <v-spacer></v-spacer>
                    <profile-text
                      title="Parentesco : "
                      style="margin-top: -0.4rem"
                      v-model="user.parentesco"
                      :editing="user.id === idparente"
                      :last="true"
                    ></profile-text>
                  </h3>
                </div>
                <div class="sm9 ml-3 pb-4">
                  <v-icon size="25" @click="editparentesco(user.id)" v-if="editing">edit</v-icon>
                </div>
              </v-layout>
              <div v-if="editing">
                <v-layout>
                  <!-- <v-btn color="primary" 
                                flat 
                                @click.stop="existe = true, selecao = false">
                                Parentes existentes
                  </v-btn>-->
                  <v-spacer></v-spacer>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <v-select
                      v-if="selecao"
                      :key="familiares"
                      v-model="tempData.familiares"
                      :items="tempData.familiares"
                      item-text="parente.username"
                      chips
                      return-object
                      label="Lista de parentes"
                      multiple
                    ></v-select>
                  </v-flex>
                  <!-- Dialog - parente existente -->
                  <v-dialog
                    v-model="existe"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                    scrollable
                  >
                    <dialog-parente @close="existe=false, selecao = true" @existente="atualdados"></dialog-parente>
                  </v-dialog>
                </v-layout>
              </div>
            </v-tab-item>
            <v-tab-item key="Avaliação" class="px-3 py-2">
              <!-- <v-layout row wrap align-end>
                              <v-flex>
                                <h1> Busca de Avaliação</h1>
                                <v-spacer></v-spacer>
                              </v-flex>
                              <v-flex>
                                <v-text-field
                                  append-icon="search"
                                  single-line
                                  hide-details
                                  v-model="search"
                              ></v-text-field>
                              </v-flex>
                              </v-layout>
              -->
              <tree-map
                v-if="show_plot && criterios_selecionados.length > 0"
                :tree_data="criterios_tree"
                class="text-lg-center hidden-md-and-down"
              ></tree-map>
              <v-data-table
                class="mt-4"
                :items="criterios_selecionados"
                hide-actions
                :headers="headers"
                item-key="id"
                :search="search"
                :loading="animation"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="gotoAval(props.item)"
                    class="text-xs-left"
                  >{{ props.item.criterio.classificacao }}</td>
                  <td
                    @click="gotoAval(props.item)"
                    class="text-xs-left"
                  >{{ props.item.criterio.grupo }}</td>
                  <td
                    @click="gotoAval(props.item)"
                    class="text-xs-left"
                  >{{ props.item.criterio.subgrupo }}</td>
                  <td @click="gotoAval(props.item)">{{ props.item.criterio.name }}</td>
                  <td class="text-xs-right px-0 mx-0" style="min-width:200px">
                    <v-tooltip bottom>
                      <rate
                        :length="4"
                        style
                        slot="activator"
                        v-model="props.item.valor"
                        :readonly="true"
                      />
                      <span>{{props.item.criterio['rubrica_' + props.item.valor].description }}</span>
                    </v-tooltip>
                  </td>
                </template>
                <template slot="no-data">Ops... Nenhum dado no momento</template>
              </v-data-table>
            </v-tab-item>
          </v-tabs>

          <v-btn
            v-if="this.$store.state.selectedRole.name === 'Admin' || permissao "
            absolute
            dark
            fab
            bottom
            right
            class="destaca"
            color="blue"
            @click="pressFloatingButton()"
          >
            <v-icon v-if="!editing">mode_edit</v-icon>
            <v-icon v-else>done</v-icon>
          </v-btn>
        </v-card-text>
        <!-- VISAO DE MAKERLAB -->
        <v-card-text class="mx-0 px-0 mt-0 pt-0" v-if="isMakerlab">
          <v-tabs color="blue lighten-1" dark class="mx-0 pt-0 mt-0">
            <v-tab
              class="mx-0 pt-0 mt-0"
              v-for="tab in tabsLab"
              :key="tab.name"
              v-if="hasPerm(tab.permission)"
              @click="show_plot=true"
            >{{ tab.name }}</v-tab>
            <v-tab style="margin-left: 320px">
              <v-icon v-if="editing" size="25" @click="dialog = true" style="float: right">delete</v-icon>
            </v-tab>

            <v-tab-item key="Portfólio" class="px-3 py-2" v-if="isStudent" >
              <v-container fluid class="mx-0 px-0">
                <v-spacer></v-spacer>
                <v-icon class="lupa" @click="filtroEvid = true">search</v-icon>
                <!-- <div class="my-cards"> -->
                <v-layout xs12 row wrap>
                  <v-flex xs6 
                    v-for="(evidencia, index) in evidencias.results"
                    :key="evidencia.id">
                    <transition-group
                      :duration="600"
                    >   
                      <v-card 
                        key="card.id"
                        class="ma-2"
                        >
                        
                        <v-card-title class="text-xs-center " >
                            <v-layout row @click="expandir(index)" >
                                <v-flex xs10>
                                  <h2 class="headline" style="text-align: left">{{evidencia.title}}</h2>
                                </v-flex>
                                <v-flex xs2 v-if="evidencia.image">
                                  <img :src="evidencia.image" height="60" width="60" alt="">
                                </v-flex>
                                <!-- <v-flex xs5>
                                    <v-layout row style="text-align: right" align-content-end
                                      justify-end>
                                        <v-spacer></v-spacer>

                                    <v-layout align-end column class='mr-2'>
                                        <v-flex>  
                                        <h4>
                                            {{evidencia.author}}
                                        </h4>
                                        </v-flex>
                                        <v-flex>
                                        {{ evidencia.modified | moment('LL') }}
                                        </v-flex>
                                    </v-layout>
                                        <div v-if="evidencia.auto_avaliado" style="height: 55px; width: 55px; background: #90e1f0 ; border-radius: 30px ">
                                            <v-avatar class="ma-1">
                                                <img :src="userData.profilePic" @error="imageError()" alt="" style="margin-right: 2px" >
                                            </v-avatar>
                                            <div class="badge1">
                                                <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                                <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                                            </div>
                                        </div>
                                        <div v-else >
                                            <v-avatar >
                                                <img :src="userData.profilePic" alt="" >
                                            </v-avatar>
                                            <div class="badge1">
                                                <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                                <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                                            </div>
                                        </div>

                                    </v-layout>
                                </v-flex> -->
                                <!-- <div style="height: 65px"></div> -->
                            </v-layout> 
                          </v-card-title>
                          <v-layout row wrap>
                            <a v-if="showBtn" @click="expandir(index)" ></a>
                            <div v-if="evidencia.audio !== null" >
                              <v-icon class="ml-2">audiotrack</v-icon>
                            </div>
                            <div v-if="evidencia.video !== null">
                              <v-icon class="ml-2">play_circle_outline</v-icon>
                            </div>
                          </v-layout>
                        </v-card>
                        <div key="div.id">
                          <v-dialog v-model="dialogEvi[index]" max-width="500"> 
                            <evidencia
                              class="mb-2"
                              style="display: inline-block; width:100%;"
                              :image="userData.profilePic"
                              :evidencia="evidencias.results[index]"
                              :avaliavel="true"
                              moreopts="true"
                              @changed="mudouEvidencia"
                              @exclui="retirarevid"
                              @avaliar="abrirAvaliacao(evidencia)"
                            />
                          </v-dialog>
                        </div>
                    </transition-group>
                  <!-- </div> -->
                  </v-flex>
                </v-layout>
              </v-container>
              <v-flex xs12 justify-center class="text-xs-center mt-3">
                <v-pagination :length="evidencias.pages" total-visible="7" circle v-model="page"></v-pagination>      
              </v-flex>
            </v-tab-item>
            <v-tab-item key="Avaliação" class="px-3 py-2" v-if="isStudent">
              <!-- <v-layout row wrap align-end>
                              <v-flex>
                                <h1> Busca de Avaliação</h1>
                                <v-spacer></v-spacer>
                              </v-flex>
                              <v-flex>
                                <v-text-field
                                  append-icon="search"
                                  single-line
                                  hide-details
                                  v-model="search"
                              ></v-text-field>
                              </v-flex>
                              </v-layout>
              -->
              <tree-map
                v-if="show_plot && criterios_selecionados.length > 0"
                :tree_data="criterios_tree"
                class="text-lg-center hidden-md-and-down"
              ></tree-map>
              <v-data-table
                class="mt-4"
                :items="criterios_selecionados"
                hide-actions
                :headers="headers"
                item-key="id"
                :search="search"
                :loading="animation"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="gotoAval(props.item)"
                    class="text-xs-left"
                  >{{ props.item.criterio.classificacao }}</td>
                  <td
                    @click="gotoAval(props.item)"
                    class="text-xs-left"
                  >{{ props.item.criterio.grupo }}</td>
                  <td
                    @click="gotoAval(props.item)"
                    class="text-xs-left"
                  >{{ props.item.criterio.subgrupo }}</td>
                  <td @click="gotoAval(props.item)">{{ props.item.criterio.name }}</td>
                  <td class="text-xs-right px-0 mx-0" style="min-width:200px">
                    <v-tooltip bottom>
                      <rate
                        :length="4"
                        style
                        slot="activator"
                        v-model="props.item.valor"
                        :readonly="true"
                      />
                      <span>{{props.item.criterio['rubrica_' + props.item.valor].description }}</span>
                    </v-tooltip>
                  </td>
                </template>
                <template slot="no-data">Ops... Nenhum dado no momento</template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item key="Sobre" class="px-3 py-2">
              <profile-text
                title="Email : "
                v-model="tempData.email"
                :editing="editing"
              ></profile-text>
              <profile-text
                title="Nome de usuário : "
                v-model="userData.username"
              ></profile-text>
              <profile-text
                title="Papeis : "
                chiplist
                v-model="tempData.groups"
                :editing="editing"
                inputType="multiselect"
                :selectOptions="options.groups"
              ></profile-text>
              <profile-text
                title="Unidades : "
                chiplist
                v-model="tempData.unidade"
                :editing="editing"
                inputType="multiunidade"
                :selectOptions="unidadeDisponivel"
              ></profile-text>
              <profile-text
                title="Mediador : "
                :editing="editing"
                v-if="isStudent"
                v-model="selectedMediador"
                showbykey="full_name"
                inputType="mediadorselect"
                :selectOptions="availableMediadores"
                :last="true"
              ></profile-text>
            </v-tab-item>
            <v-tab-item key="Segurança" class="px-3 py-2" v-if="isStudent">
              <v-form ref="form" @submit.prevent="eventSaved">
                <v-text-field
                  v-model="password"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Senha"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-text-field
                  v-model="confirmpass"
                  :append-icon="show2 ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required]"
                  :type="show2 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Confirme a nova senha"
                  hint="Repita sua senha"
                  counter
                  @click:append="show2 = !show2"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" @click.prevent="eventSaved">Alterar</v-btn>
              </v-form>
            </v-tab-item>
            <!-- <v-tab-item v-if="isStudent" key="Adicionais" class="px-3 py-2">
              <profile-text
                title="Restrições : "
                :last="true"
                v-model="tempData.restricao"
                :editing="editing"
                input-type="multilinetext"
              ></profile-text>
              <profile-text
                title="Doenças : "
                v-model="tempData.doenca"
                :last="true"
                :editing="editing"
                input-type="multilinetext"
              ></profile-text>
              <profile-text
                title="Tratamento : "
                v-model="tempData.tratamento"
                :last="true"
                :editing="editing"
                input-type="multilinetext"
              ></profile-text>
            </v-tab-item> -->
            <v-tab-item key="Familiares" class="px-3 py-2">
              <h3 v-if="hasAlunos">Alunos</h3>
              <v-layout class="row" v-for="user in userData.alunos" :key="user.username">
                <div class="sm3 pb-2">
                  <router-link :to="user.username">
                    <v-avatar>
                      <img :src="imageDefault(user.profilePic)">
                    </v-avatar>
                  </router-link>
                </div>
                <div class="sm9 ml-3 mt-3">
                  <router-link :to="user.username">
                    <h3 class>
                      {{user.username + ' - ' +
                      user.first_name + ' ' +
                      user.last_name}}
                    </h3>
                  </router-link>
                </div>
              </v-layout>
              <h3 v-if="hasDependentes">Dependentes</h3>
              <v-layout class="row" v-for="user in userData.dependentes" :key="user.username">
                <div class="sm3 pb-2">
                  <router-link :to="user.aluno.username">
                    <v-avatar>
                      <img :src="imageDefault(user.aluno.profilePic)">
                    </v-avatar>
                  </router-link>
                </div>
                <div class="sm9 ml-3 mt-3">
                  <router-link :to="user.aluno.username">
                    <h3 class>
                      {{user.aluno.username + ' - ' +
                      user.aluno.first_name + ' ' +
                      user.aluno.last_name}}
                    </h3>
                  </router-link>
                </div>
              </v-layout>
              <h3 class="mb-1" v-if="hasFamiliares">Parentes</h3>
              <v-layout class="row" v-for="user in tempData.familiares" :key="user.username">
                <div class="sm3">
                  <router-link :to="user.parente.username">
                    <v-avatar>
                      <img :src="imageDefault(user.parente.profilePic)">
                    </v-avatar>
                  </router-link>
                </div>
                <div class="sm9 ml-3 pb-4">
                  <h3>
                    <router-link :to="user.parente.username">
                      {{user.parente.username + ' - ' + user.parente.first_name + ' ' + user.parente.last_name}}
                      <v-icon
                        v-if="canSeeLegal && user.respfinanceiro"
                        style="margin-bottom: 6px"
                      >monetization_on</v-icon>
                    </router-link>
                    <v-spacer></v-spacer>
                    <profile-text
                      title="Parentesco : "
                      style="margin-top: -0.4rem"
                      v-model="user.parentesco"
                      :editing="user.id === idparente"
                      :last="true"
                    ></profile-text>
                  </h3>
                </div>
                <div class="sm9 ml-3 pb-4">
                  <v-icon size="25" @click="editparentesco(user.id)" v-if="editing">edit</v-icon>
                </div>
              </v-layout>
              <div v-if="editing">
                <v-layout>
                  <!-- <v-btn color="primary" 
                                flat 
                                @click.stop="existe = true, selecao = false">
                                Parentes existentes
                  </v-btn>-->
                  <v-spacer></v-spacer>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <v-select
                      v-if="selecao"
                      :key="familiares"
                      v-model="tempData.familiares"
                      :items="tempData.familiares"
                      item-text="parente.username"
                      chips
                      return-object
                      label="Lista de parentes"
                      multiple
                    ></v-select>
                  </v-flex>
                  <!-- Dialog - parente existente -->
                  <v-dialog
                    v-model="existe"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                    scrollable
                  >
                    <dialog-parente @close="existe=false, selecao = true" @existente="atualdados"></dialog-parente>
                  </v-dialog>
                </v-layout>
              </div>
            </v-tab-item>
          </v-tabs>

          <v-btn
            v-if="this.$store.state.selectedRole.name === 'Admin' || permissao "
            absolute
            dark
            fab
            bottom
            right
            class="destaca"
            color="blue"
            @click="pressFloatingButton()"
          >
            <v-icon v-if="!editing">mode_edit</v-icon>
            <v-icon v-else>done</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-snackbar v-model="snackbar" bottom :color="cor">
      {{ text }}
      <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Deseja deletar?</v-card-title>
        <v-card-text>Gostaria excluir esse usuário?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
          <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog v-model="filtroEvid" persistent max-width="400">
        <v-card>
          <v-card-title class="headline"> <v-spacer></v-spacer> Filtro de evidências?<v-spacer></v-spacer> </v-card-title>
          <v-card-text>
            <!-- <v-autocomplete 
              label="Autores"
              items="projetoData.integrantes"
              item-text="username"
              item-value="id"
              autocomplete
              v-model="alunoFilter"
              hint="Escolha o aluno"
              style="margin-bottom: 15px"
            ></v-autocomplete> -->
            <v-checkbox label="Avaliadas"
              class="upCheck"
              v-if="!isNotAvaliada"
              v-model="isAvaliada"></v-checkbox>
            <v-checkbox label="Não avaliadas"
              class="upCheck"
              v-if="!isAvaliada"
              v-model="isNotAvaliada"></v-checkbox>
            <v-checkbox label="Evidência foco"
              class="upCheck"
              v-if="!isNotFocus"
              v-model="isFocus"></v-checkbox>
            <v-checkbox label="Evidência não foco"
              class="upCheck"
              v-if="!isFocus"
              v-model="isNotFocus"></v-checkbox>
            <v-layout row wrap>
                <v-flex xs6>
                  <v-menu
                    ref="menu"
                    lazy
                    :close-on-content-click="false"
                    v-model="menu"
                    transition="scale-transition"
                    offset-y
                    style="width: 80%"
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Data de início"
                      v-model="computedDateFormatted"
                      prepend-icon="event"
                    ></v-text-field>
                    <v-date-picker v-model="dateInicio" no-title scrollable
                      locale="pt-br">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(dateInicio)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    ref="menu2"
                    lazy
                    :close-on-content-click="false"
                    v-model="menu2"
                    transition="scale-transition"
                    offset-y
                    style="width: 80%"
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Data do fim"
                      v-model="computedDateFormatted2"
                      prepend-icon="event"
                    ></v-text-field>
                    <v-date-picker v-model="dateFim" no-title scrollable
                      locale="pt-br">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu2.save(dateFim)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="fecharFiltro()">Limpar</v-btn>
            <v-btn color="green darken-1" flat @click.native="filtrar()">Pesquisar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </v-layout>
</template>

<script>
import api from '@/api';
import config from '@/config';
import DialogParente from '@/components/reusable/DialogParente.vue';
import ProfileText from '@/components/reusable/ProfileText.vue';
import ChangeImage from '@/components/reusable/ChangeImage.vue';
import Rate from '@/components/reusable/Rate.vue';
import TreeMap from '@/components/reusable/TreeMap.vue';
import Evidencia from '@/components/reusable/evidencia.vue';

export default {
  components: {
    DialogParente,
    ProfileText,
    ChangeImage,
    Evidencia,
    Rate,
    TreeMap
  },
  data () {
    return {
      userData: {
        groups: [],
        dependentes: [],
        familiares: []
      },
      show1: false,
      showBtn: true,
      page: 1,
      show2: false,
      evidencias: [],
      dialogEvi: [false, false, false, false, false, false, false, false, false],
      password: '',
      confirmpass: '',
      rules: {
        required: value => !!value || 'Required.' },
      currentTab: 'Sobre',
      compLab: [],
      showImageUpload: false,
      parenteid: '',
      imageChangeModal: false,
      animation: true,
      snackbar: false,
      cor: '',
      text: '',
      search: '',
      pesquisa: '',
      selecao: false,
      filtroEvid: false,
      isAvaliada: false,
      isFocus: false,
      isNotFocus: false,
      isNotAvaliada: false,
      menu: false,
      menu2: false,
      dateFim: '',
      dateInicio: '',
      idparente: '',
      editing: false,
      tempData: {},
      unidadeDisponivel: {},
      headers: [
        { text: 'Classificação', sortable: false, value: 'classificacao' },
        { text: 'Grupo', sortable: false, value: 'grupo' },
        { text: 'Subgrupo', sortable: false, value: 'subgrupo' },
        { text: 'Habilidade', sortable: false, value: 'name' },
        { text: 'Nota', sortable: false, value: 'rubrica' }
      ],
      options: {
        unidades: []
      },
      selectedMediador: {},
      selectedMediadorTemp: {},
      familiares: [],
      parentescoedit: false,
      grades: [],
      existe: false,
      dialog: false,
      show_plot: false,
      criterios_selecionados: [],
      classificacoes: [],
      tabNames: [
        { name: 'Sobre', permission: 'all' },
        { name: 'Pessoal', permission: 'all' },
        { name: 'Adicionais', permission: 'all' }, // legal
        { name: 'Endereço', permission: 'all' }, // address
        { name: 'Familiares', permission: 'all' },
        { name: 'Avaliação', permission: 'isStudent' }
      ],
      tabNamesMakerlab: [
        { name: 'Portfólio', permission: 'isStudent' },
        { name: 'Avaliação', permission: 'isStudent' },
        { name: 'Sobre', permission: 'all' },
        { name: 'Segurança', permission: 'isAluno' }
      ]
    };
  },
  computed: {
    criterios_tree () {
      console.log('crit', this.criterios_selecionados)
      var tree = {
        name: 'Avaliações',
        children: []
      };
      console.log('-----CREATING TREE-------');
      var handle = tree.children;
      this.criterios_selecionados.forEach(criterio => {
        // Trata Categoria
        var hasCategoria = handle.find(categoria => {
          return categoria.name === criterio.criterio.classificacao;
        });
        console.log('secod step', hasCategoria);
        if (hasCategoria) {
          handle = hasCategoria.children;
        } else {
          handle.push({
            name: criterio.criterio.classificacao,
            children: []
          });
          handle = handle[handle.length - 1].children;
        }

        // Trata Grupo
        var hasGrupo = handle.find(grupo => {
          return grupo.name === criterio.criterio.grupo;
        });
        if (hasGrupo) {
          handle = hasGrupo.children;
        } else {
          handle.push({
            name: criterio.criterio.grupo,
            children: []
          });
          handle = handle[handle.length - 1].children;
        }

        // Trata subGrupo
        var hasSubGrupo = handle.find(subgrupo => {
          return subgrupo.name === criterio.criterio.subgrupo;
        });
        if (hasSubGrupo) {
          handle = hasSubGrupo.children;
        } else {
          handle.push({
            name: criterio.criterio.subgrupo,
            children: []
          });
          handle = handle[handle.length - 1].children;
        }

        // Trata criterio
        var hasCriterio = handle.find(subgrupo => {
          return subgrupo.name === criterio.criterio.name;
        });
        if (hasCriterio) {
        } else {
          handle.push({
            name: criterio.criterio.name,
            value: Math.pow(criterio.valor, 2),
            real_value: criterio.valor,
            id: criterio.id
          });
        }

        // reset handle
        handle = tree.children;
      });
      return tree;
    },
    tabs () {
      if (!this.isStudent) {
        return [
          { name: 'Sobre', permission: 'all' },
          { name: 'Pessoal', permission: 'all' },
          { name: 'Endereço', permission: 'all' }, // address
          { name: 'Alunos', permission: 'all' }
        ];
      } else {
        return this.tabNames;
      }
    },
    tabsLab () {
      if (!this.isStudent) {
        return [
          { name: 'Sobre', permission: 'all' },
          { name: 'Alunos', permission: 'all' }
        ];
      } else {
        return this.tabNamesMakerlab;
      }
    },
    usrCalendar () {
      return '/calendario/usuario/' + this.userData.username;
    },
    availableMediadores () {
      var mediadores = [];
      this.options.unidades.forEach(unidade => {
        mediadores.push({ header: unidade.unidade });
        unidade.mediadores.forEach(med => {
          mediadores.push(med);
        });
      });
      return mediadores;
    },
    hasDependentes () {
      return this.userData.dependentes.length > 0;
    },
    hasAlunos () {
      return this.userData.alunos.length > 0;
    },
    hasFamiliares () {
      return this.userData.familiares.length > 0;
    },
    isStudent () {
      return (
        this.userData.groups.filter(function (group) {
          return group === 'Aluno';
        }).length === 1
      );
    },
    isWorker () {
      return (
        this.userData.groups.filter(function (group) {
          return group === 'Mediador' || group === 'Admin';
        }).length >= 1
      );
    },
    isTeacher () {
      return (
        this.userData.groups.filter(function (group) {
          return group === 'Mediador';
        }).length === 1
      );
    },
    isRelative () {
      return (
        this.userData.groups.filter(function (group) {
          return group === 'Parente';
        }).length === 1
      );
    },
    fullName () {
      if (this.userData === null) {
        return '';
      } else if (this.userData === undefined) {
        return '';
      } else {
        return this.userData.first_name + ' ' + this.userData.last_name;
      }
    },
    pictureUrl () {
      return config.imageServerURI + this.userData.profilePic;
    },
    canEdit () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return this.$store.state.user.id === this.userData.id;
        } else {
          return (
            this.$store.state.user.id === this.userData.id ||
            this.$store.state.selectedRole.permissions.includes(
              'core | Usuário | Can edit users'
            )
          );
        }
      }
    },
    canExtraEdit () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return false;
        } else {
          return this.$store.state.selectedRole.permissions.includes(
            'core | Usuário | can edit users'
          );
        }
      }
    },
    canSeeLegal () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return this.$store.state.user.id === this.userData.id;
        } else {
          return (
            this.$store.state.user.id === this.userData.id ||
            this.$store.state.selectedRole.permissions.includes(
              'core | Usuário | can see users legal info'
            )
          );
        }
      }
    },
    canSeeAdress () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return false;
        } else {
          return (
            this.$store.state.user.id === this.userData.id ||
            this.$store.state.selectedRole.permissions.includes(
              'core | Usuário | can see users address'
            )
          );
        }
      }
    },
    canEvaluate () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return false;
        } else {
          return this.$store.state.selectedRole.permissions.includes(
            'core | Usuário | can evaluate other users progress'
          );
        }
      }
    },
    safeImage () {
      if (
        this.userData === null ||
        this.userData.profilePic === '' ||
        this.userData.profilePic === undefined
      ) {
        return config.imageServerURI + 'images/profilePlaceHolder.jpg';
      } else {
        console.log('asodiih', this.userData)
        return this.userData.profilePic_small;
      }
    },
    permissao () {
      if (this.$store.state.user.is_superuser) {
        return true
      } else {
        return this.$store.state.details.can_delete_user
      }
    },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  },
  watch: {
    page (val, oldVal) {
      this.getEvidencia(val);
    }
  },
  mounted () {
    let self = this;
    var username = this.$route.params.username;
    api
      .request('GET', 'user-edit-options/' + username + '/')
      .then(function (response) {
        self.options = response.data;
        console.log(response.data);
      });
    api.request('GET', 'users/?username=' + username).then(response => {
      self.userData = response.data[0];
      console.log('get user', response.data[0]);
      self.tempData = _.cloneDeep(response.data[0]);
      self.selectedMediador = self.findMediador(self.tempData.mediador);
      self.selectedMediadorTemp = _.cloneDeep(self.selectedMediador);

      if (this.isStudent) {
        api
          .request('GET', 'avaliacaorecente/?aluno__username=' + username)
          .then(response => {
            this.grades = response.data;
            this.criterios_selecionados = response.data;
            console.log(response.data);
            this.formataCriterios();
            this.criaArrayClassif();
            this.animation = false;
          })
      }

      api.request('GET', 'unidade/').then(resp => {
      // this.unidadeDisponivel = resp.data
        this.listaUnidade(resp.data)
        api.request('GET', 'companies/' + this.userData.company).then(resp => {
          this.compLab = resp.data
        })
      })
    }).then(() => {
      this.getEvidencia()
    })
  },
  methods: {
    pressFloatingButton () {
      if (this.editing) {
        this.performSave();
      } else {
        this.editing = !this.editing;
      }
    },
    getEvidencia (page = 1) {
      api
        .request(
          'GET',
          'evidencias/?page=' + page +
          '&author=' + this.userData.id +
          this.pesquisa
        )
        .then(response => {
          this.evidencias = response.data;
          console.log('evid', response);
          this.filtroEvid = false
          this.waiting = false;
        });
    },
    abrirAvaliacao (evidencia) {
      this.evid_avaliada = evidencia;
      // this.avaliando = true
      this.$store.commit('SET_EVID', evidencia);
      this.$router.push('/projetos/' + evidencia.id + '/avaliacao');
    },
    expandir (i) {
      this.showBtn = false
      this.dialogEvi[i] = true
      this.showBtn = true
    },
    retirarevid (retirar) {
      var posic;
      var busca = this.evidencias.results.some((evid, index) => {
        posic = index;
        return retirar === evid.id;
      });
      if (!busca) {
        // console.log('Erro');
        return false;
      }
      this.evidencias.results.splice(posic, 1);
      this.snackbar = true;
    },
    excluir () {
      api.request('DELETE', 'users/' + this.userData.id + '/').then(resp => {
        this.$router.push('/usuarios/busca');
      });
    },
    // getEvidencia (id) {
    //   var nome = api.request('GET', 'evidencias/' + id + '/').then(response => {
    //     api.request('GET', 'projetos/' + response.data.project + '/').then(resp => {
    //       console.log(resp.data.name)
    //       return resp.data.name
    //     })
    //   })
    //   return nome
    // },
    imageError () {
      this.onerror = null
      this.$refs.logo.src = this.userData.profilePic
    },
    editparentesco (id) {
      this.idparente = id;
      if (this.parentescoedit) {
        this.changeparentesco(id);
      } else {
        this.parentescoedit = !this.parentescoedit;
      }
    },
    mudouEvidencia (evidencia) {
      // console.log('evidencia', evidencia)
      var ind;
      var found = this.evidencias.results.some((evid, index) => {
        ind = index;
        return evidencia.id === evid.id;
      });
      if (!found) {
        // console.log('Erro');
        return false;
      }
      this.evidencias.results.splice(ind, 1, evidencia);
      // console.log(ind)
    },
    changeparentesco (id) {
      var parente = this.tempData.familiares.filter(parente => {
        return parente.id === id;
      });
      api
        .request('PATCH', 'familiar/' + id + '/', {
          parentesco: parente[0].parentesco
        })
        .then(resp => {
          this.idparente = 0;
          this.parentescoedit = false;
        });
    },
    urlCalendar () {
      this.$router.push('/calendario/usuario/' + this.userData.username);
    },
    gotoAval (row) {
      this.$router.push({ name: 'avaliacao', params: { id: row.evidencia } });
    },
    hasPerm (perm) {
      switch (perm) {
        case 'all':
          return true;
        case 'address':
          return this.canSeeAdress;
        case 'legal':
          return this.canSeeLegal;
        case 'ismediador':
          return this.userData.isWorker === 1;
        case 'isAluno':
          return this.$store.state.selectedRole.name !== 'Aluno';
        default:
          return true;
      }
    },
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade);
    },
    findMediador (username) {
      var mediadores = [];
      this.options.unidades.forEach(unidade => {
        mediadores = _.union(mediadores, unidade.mediadores);
      });
      var resposta = mediadores.filter(
        mediador => mediador.username === username
      )[0];
      if (resposta === null || resposta === undefined) {
        return {
          full_name: username,
          username: username,
          id: null
        };
      } else {
        return resposta;
      }
    },
    performSave () {
      if (this.parentescoedit) {
        this.editparentesco(this.idparente);
      }
      let self = this;
      delete this.tempData['profilePic'];
      this.tempData.mediador = this.selectedMediador.username;
      var id = this.userData.id;
      if (this.isTeacher) {
        delete this.tempData.mediador;
      }
      if (this.tempData.mediador === null) {
        delete this.tempData.mediador;
      }
      console.log(this.tempData);
      api
        .request('PATCH', 'users/' + id + '/', this.tempData)
        .then(function (response) {
          self.userData = response.data;
          self.tempData = _.cloneDeep(self.userData);
          self.selectedMediador = self.findMediador(self.tempData.mediador);
        });
      this.editing = false;
    },
    atualdados (dados) {
      this.tempData.familiares.push(dados);
      console.log(this.tempData);
    },
    listaUnidade (lista) {
      console.log('get unidade', lista)
      var compUnidade = lista.filter(comp => {
        return (comp.company === this.userData.company)
      })
      console.log('lsita', compUnidade)
      console.log('compa', this.userData.company)
      this.unidadeDisponivel = compUnidade
      return compUnidade
    },
    pegaid (id) {
      this.parenteid = id;
      console.log(id);
    },
    clean (del) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] === del) {
          this.splice(i, 1);
          i--;
        }
      }
      return this;
    },
    imageDefault (image) {
      if (image === null) {
        return config.imageServerURI + 'images/profilePlaceHolder.jpg';
      } else {
        return image;
      }
    },
    linkCreate (username) {
      if (username === null) {
        return '';
      } else {
        return config.appServerURI + 'perfil/' + username;
      }
    },
    imageCropped (image) {
      this.$store.commit('TOGGLE_LOADING');
      var path = 'users/' + this.userData.id + '/';

      var name =
        'images/users/' +
        'profilePic_' +
        this.userData.id +
        '.jpg&' +
        new Date().getTime();

      var upload = this.fbstorage.child(name).putString(image, 'data_url');

      upload.on(
        'state_changed',
        snapshot => console.log(snapshot),
        error => console.log(error),
        url => {
          console.log(upload.snapshot);
          var payload = {
            profilePic: name
          };
          api
            .request('PATCH', path, payload)
            .then(response => {
              this.userData = response.data;
              this.$store.commit('SET_USER_IMAGE', this.userData.profilePic);
              this.$store.commit('TOGGLE_LOADING');
            })
            .catch(function (error) {
              this.$store.commit('TOGGLE_LOADING');
              console.log(error);
            });
        }
      );

      this.imageChangeModal = false;
    },
    formataCriterios () {
      function compare (a, b) {
        a = a.criterio;
        b = b.criterio;
        if (a.classificacao < b.classificacao) {
          return -1;
        } else if (a.classificacao > b.classificacao) {
          return 1;
        } else {
          if (a.grupo < b.grupo) {
            return -1;
          } else if (a.grupo > b.grupo) {
            return 1;
          } else {
            if (a.subgrupo < b.subgrupo) {
              return -1;
            } else if (a.subgrupo > b.subgrupo) {
              return 1;
            } else {
              if (a.name < b.name) {
                return -1;
              } else if (a.name > b.name) {
                return 1;
              } else {
                return 0;
              }
            }
          }
        }
      }

      this.criterios_selecionados.sort(compare);
    },
    criaArrayClassif () {
      this.criterios_selecionados.forEach(crit => {
        var critBck = crit;
        crit = crit.criterio;
        var found = this.classificacoes.filter(el => {
          return el.name === crit.classificacao;
        });
        if (found.length <= 0) {
          this.classificacoes.push({
            name: crit.classificacao,
            grupos: [
              {
                name: crit.grupo,
                subgrupos: [
                  {
                    name: crit.subgrupo,
                    criterios: [crit]
                  }
                ]
              }
            ]
          });
        } else {
          var found2 = found[0].grupos.filter(el => {
            return el.name === crit.grupo;
          });
          if (found2.length <= 0) {
            found[0].grupos.push({
              name: crit.grupo,
              subgrupos: [
                {
                  name: crit.subgrupo,
                  criterios: [crit]
                }
              ]
            });
          } else {
            var found3 = found2[0].subgrupos.filter(el => {
              return el.name === crit.subgrupo;
            });
            if (found3.length <= 0) {
              found2[0].subgrupos.push({
                name: crit.subgrupo,
                criterios: [critBck]
              });
            } else {
              var found4 = found3[0].criterios.filter(el => {
                return el.name === crit.name;
              });
              if (found4.length <= 0) {
                found3[0].criterios.push(critBck);
              } else {
              }
            }
          }
        }
      });
    },
    filtrar () {
      this.pesquisa = ''
      if (this.isAvaliada) {
        this.pesquisa = this.pesquisa + '&is_evaluated=true'
      }
      if (this.isNotAvaliada) {
        this.pesquisa = this.pesquisa + '&is_not_evaluated=true'
      }
      if (this.isFocus) {
        this.pesquisa = this.pesquisa + '&is_focus_evidence=true'
      }
      if (this.isNotFocus) {
        this.pesquisa = this.pesquisa + '&is_not_focus_evidence=true'
      }
      if (this.dateInicio) {
        this.pesquisa = this.pesquisa + '&created__gte=' + this.dateInicio + 'T00:00:19.920Z'
      }
      if (this.dateFim) {
        this.pesquisa = this.pesquisa + '&created__lte=' + this.dateFim + 'T23:30:19.920Z'
      }
      this.getEvidencia()
    },
    fecharFiltro () {
      this.pesquisa = ''
      this.page = 1
      this.isAvaliada = false
      this.isFocus = false
      this.isNotFocus = false
      this.isNotAvaliada = false
      this.dialogFiltro = false
      this.getEvidencia()
    },
    eventSaved () {
      if (this.password !== this.confirmpass) {
        this.text = 'As senhas devem ser iguais';
        this.cor = 'error';
        this.snackbar = true;
      } else {
        let payload = {
          user: this.userData.id,
          new_password: this.password
        };
        api
          .request('PUT', 'change-password-as-admin/', payload).then(resp => {
            console.log('resp pass', resp)
            if (resp.status === 200) {
              this.text = 'A senha do ' + this.userData.username + ' foi alterada com sucesso';
              this.cor = 'success';
              this.snackbar = true;
            } else {
              this.text = 'A senha do ' + this.userData.username + ' foi não alterada!';
              this.cor = 'error';
              this.snackbar = true;
            }
          })
      }
    }
  },
  beforedDestroy () {
    this.$store.commit('RESET_SELECTED_USER');
  }
};
</script>

<style lang="scss" scoped>
.image-edit {
  margin-right: -20px;
  margin-bottom: 15px;
}
.smaller-tabs {
  .tabs__div {
    font-size: 0.9rem;
  }
}
.tab__items {
  padding: 20px;
}
.destaca:focus {
  color: blue;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Usuarios/Detail.vue